/* @flow strict */

import i18n from 'i18next';

export default (key: string): string => {
  return i18n.isInitialized && i18n.exists(key) ? i18n.t(key) : key;
};
